import {
  NormalizedRealtimePayload,
  RealtimePayload,
} from 'src/interfaces/api.types';
import { pipe } from 'src/utils/pipe';

const normalizeDesmosAssignmentEvent = (
  event: RealtimePayload,
  classesIds: string[],
): { event: RealtimePayload; classesIds: string[] } => {
  const normalizedEvent =
    event.sender === 'desmos'
      ? {
          ...event,
          newActivitiesCount: !event.isDeleted
            ? event.assignedContent.length
            : undefined,
          assignedContent: event.assignedContent.map((activity) => {
            return {
              ...activity,
              classBk: event.classBk ?? '',
              activitiesBks: activity.content?.activityId
                ? [activity.content.activityId]
                : [],
            };
          }),
        }
      : event;

  return { event: normalizedEvent, classesIds };
};

const filterByClasses = ({
  event,
  classesIds,
}: {
  event: RealtimePayload;
  classesIds: string[];
}): RealtimePayload => {
  return {
    ...event,
    assignedContent: event.assignedContent.filter((item) =>
      classesIds.includes(item.classBk),
    ),
  };
};

const collectAssignedContentBks = (
  event: RealtimePayload,
): NormalizedRealtimePayload => {
  const { assignedContent, ...rest } = event;

  return {
    ...rest,
    activitiesBks: event.assignedContent
      .map((item) => item.activitiesBks)
      .flat(),
  };
};

export const normalizeAssignmentEvent = pipe(
  normalizeDesmosAssignmentEvent,
  filterByClasses,
  collectAssignedContentBks,
);
